module.exports = __webpack_public_path__ + "static/img/ds-logo.73c8340.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/ds-logo.png
// module id = cexT
// module chunks = 1